const lokalizacjaZasieg = {
    name: 'lokalizacja-zasieg',
    inputs: {
        lokalizacja: { t: 'Lokalizacja', name: 'lokalizacja', hint: { url: '/location', allowOnly: /^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż\s\-]+$/ }},
        zasieg: { t: 'Zasięg', name: 'zasieg', unit: 'km', hint: { url: '/range' }},
    },
    render: 'locationRange',
    type: 'complex',
}
export default lokalizacjaZasieg